import { Skeleton } from "@/components/ui/skeleton";

export const ContentPageSkeleton = () => (
  <div className="flex min-h-screen flex-col bg-background">
    {/* Nav placeholder */}
    <Skeleton className="h-16 w-full rounded-none" />
    
    {/* Hero */}
    <Skeleton className="h-56 w-full rounded-none" />
    
    {/* Content */}
    <div className="container mx-auto px-4 py-12 max-w-4xl space-y-6">
      <Skeleton className="h-8 w-3/4" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-5/6" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-2/3" />
      <div className="pt-4 space-y-4">
        <Skeleton className="h-6 w-1/2" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-4/5" />
      </div>
      <Skeleton className="h-48 w-full rounded-lg" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-3/4" />
    </div>
  </div>
);
